// Angular
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

// NGRX
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';
import * as fromRoot from '../reducers';

export const guestCompletedResolver: ResolveFn<any> = (): Observable<any[]> => { 
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
	return store.pipe(
		select(fromRoot.getGuestState),
		filter(guests => guests.progressLoaded === true),
		take(1),
		map(guest => {
			let guests: any = [];
			store
				.pipe(
					select(fromRoot.getGuestListCompleted),
					take(1)
				)
				.subscribe(guestsCompleted => {
					guests = guestsCompleted;
				});

			return guests;
		})
	);
}